module.exports = __webpack_public_path__ + "static/media/404.4b70f5c8.png";